var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asd20-tab-bar"},[_vm._l((_vm.tabs),function(tab,index){return _c('asd20-tab',_vm._b({key:index,nativeOn:{"click":function($event){return _vm.$emit('tabClick', tab)}}},'asd20-tab',tab,false))}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }